<template>
  <tr>
    <td
      v-for="(item_key, index) in item_keys"
      :key="`${item_key}-${index}`"
      :class="getColClassesForIndex(index)">
      <table-cell-component
        :bus="bus"
        :cell_item="getItemForKey(item_key)">
      </table-cell-component>
    </td>
  </tr>
</template>
<script>
  import TableCellComponent from '@/components/layout/table/TableCellComponent'
  import { getDetailDisplayContext } from '@/utility/utility_functions'

  export default {
    name: 'table-row-component',
    props: {
      item: {
        type: Object
      },
      item_keys: {
        type: Array
      },
      display_spec: {
        type: Array
      },
      index: {
        type: Number,
        required: true
      },
      bus: {
        type: Object,
        required: true
      }
    },
    components: {
      TableCellComponent
    },
    computed: {
      displayContext: function () {
        return getDetailDisplayContext(this.item, this.display_spec)
      }
    },
    methods: {
      getItemForKey (key) {
        return this.displayContext.find(i => i.item_key === key)
      },
      getColClassesForIndex (index) {
        return this.getColClassesForKey(this.item_keys[index])
      },
      getColClassesForKey (key) {
        return this.getItemForKey(key).classes
      },
      findRowForChild (element) {
        if (this.findChild(element, this.$children)) {
          this.bus.$emit('foundRowForChild', { child: element, row: this })
        }
      },
      findChild (element, children) {
        let found = false
        for (let child of children) {
          if (child === element) {
            return true
          } else {
            found = this.findChild(element, child.$children)
          }
        }
        return found
      }
    },
    created () {
      this.bus.$on('findRowForChild', this.findRowForChild)
    }
  }
</script>
